import React from "react";

const GoodView = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5 12H2.5M5 12L6.17157 10.8284C7.98258 9.01742 9 6.56116 9 4M5 12C6.92087 13.9209 8 16.5261 8 19.2426V20M9 4V3C9 2.44772 8.55228 2 8 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H7C7.55228 22 8 21.5523 8 21V20M9 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H8M22 16.8402L21.1202 15.7844C20.2932 14.792 18.7566 14.8314 17.9815 15.8649C17.2182 16.8825 15.7117 16.9393 14.8741 15.982L14.6831 15.7638C13.7921 14.7454 12.2079 14.7454 11.3169 15.7638L11.1259 15.982C10.2883 16.9393 8.78176 16.8825 8.01852 15.8649C7.80389 15.5787 7.53087 15.3687 7.23069 15.2358M19 9C19 10.1046 18.1046 11 17 11C15.8954 11 15 10.1046 15 9C15 7.89543 15.8954 7 17 7C18.1046 7 19 7.89543 19 9Z"
        stroke="#00A3BC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GoodView;
